export default __webpack_public_path__ + "static/media/promoter.032fce64.svg";